import React from "react";

import { FloatingWindowsProvider } from "src/base-components/FloatingWindow/FloatingWindowsProvider";
import { FeatureQueryHeader } from "src/featureCatalogue/Features/FeatureQueryHeader";
import { BreadcrumbType } from "src/layout/PageHeader";
import { FEATURE_FLAGS, isFeatureFlagEnabled } from "src/router/featureFlags";

type FeatureCatalogueWrapperProps = {
  subHeaderRightContent?: React.ReactNode;
  children: React.ReactNode;
  showSubHeader?: boolean;
  breadcrumbs?: { key: string; breadcrumb: ReturnType<BreadcrumbType> }[];
  headerSideContent?: React.ReactNode;
};

export const FeatureCatalogueWrapper: React.FC<
  FeatureCatalogueWrapperProps
> = ({
  subHeaderRightContent,
  children,
  showSubHeader = true,
  breadcrumbs,
  headerSideContent,
}) => {
  const featureLifecycleEnabled = isFeatureFlagEnabled(
    FEATURE_FLAGS.featureLifecycle,
  );
  return (
    <FloatingWindowsProvider>
      <div
        className={`${featureLifecycleEnabled ? "flex h-full flex-col" : ""}`}
        data-loc="catalogue-wrapper"
      >
        <FeatureQueryHeader
          breadcrumbs={breadcrumbs ?? []}
          showSubHeader={showSubHeader}
          sideContent={headerSideContent}
          subHeaderRightContent={subHeaderRightContent}
        />
        <div
          className={`m-auto flex w-full max-w-[1800px] flex-col gap-y-5.5 px-5 pt-5 ${featureLifecycleEnabled ? "min-h-0 flex-1" : ""}`}
        >
          {children}
        </div>
      </div>
    </FloatingWindowsProvider>
  );
};
